module.exports = __webpack_public_path__ + "img/skype.4d196823.svg";